export default "__VITE_ASSET__DnQhHxbE__"